import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NbAuthService } from '@nebular/auth';
import { Observable, of } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class MenuService extends ApiService {
  constructor(http: HttpClient, authService: NbAuthService) {
    super(http, authService);
  }

  getMenus(): Observable<Menu[] | null> {
    return this.get<Menu[]>('/api/Menu/Get');
  }

  getMenuPerfilesAcciones(iIDRuta: number): Observable<ResponseMenuPerfilesAcciones[] | null> {
    if (!iIDRuta)
      return of(null);
    return this.post<ResponseMenuPerfilesAcciones[]>('/api/Menu/GetAccionesPorPerfilMenu', { "iIDRuta": iIDRuta });
  }
}

export interface Menu {
  id: string,
  title: string,
  icon: string,
  link: string,
  children: Menu[]
}

export interface RutaMenu {
  id: string,
  title: string,
  nivel: number,
}

export interface ResponseMenuPerfilesAcciones {
  iIDAccion?: number;
  bEstatus?: boolean;
}